import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import type { AuthConfig } from './types';

/** Sets up auth with SSR cookie support. Call once, at module load, before rendering. */
export const configureAuth = ({ amplify, cookieDomain }: AuthConfig) => {
  Amplify.configure(amplify, { ssr: true });

  if (cookieDomain) {
    cognitoUserPoolsTokenProvider.setKeyValueStorage(
      new CookieStorage({ domain: cookieDomain, secure: true, sameSite: 'lax', path: '/' })
    );
  }
};
